import React, { useRef, useEffect } from "react";

const MultiLineEditor = React.forwardRef((props, ref) => {
  const textareaRef = useRef();

  const maxLength = props.maxLength || props?.cellEditorParams?.maxLength || 512; // 💡 기본값 512

  useEffect(() => {
    textareaRef.current.value = props.value || "";
    textareaRef.current.focus();
  }, []);

  // Grid에서 값을 가져갈 수 있게 expose
  React.useImperativeHandle(ref, () => ({
    getValue() {
      return textareaRef.current.value;
    },
    afterGuiAttached() {
      textareaRef.current.focus();
    },
  }));

  return (
    <textarea
      ref={textareaRef}
      style={{ width: "100%", height: "100%" }}
      maxLength={maxLength}
      onKeyDown={(e) => {
        if (e.key === "Enter" && !e.shiftKey) {
          e.stopPropagation();
        }
        if (e.key === "Enter" && e.ctrlKey) {
          e.preventDefault();
          e.stopPropagation();

          const textarea = textareaRef.current;
          const start = textarea.selectionStart;
          const end = textarea.selectionEnd;
          const value = textarea.value;

          textarea.value =
            value.substring(0, start) + "\n" + value.substring(end);
          textarea.selectionStart = textarea.selectionEnd = start + 1;
        }
      }}
    />
  );
});

export default MultiLineEditor;
